import { render } from "./SchedulerApostille.vue?vue&type=template&id=5b079f8b"
import script from "./SchedulerApostille.vue?vue&type=script&lang=js"
export * from "./SchedulerApostille.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/SchedulerApostille.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b079f8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b079f8b', __exports__)) {
    api.reload('5b079f8b', __exports__)
  }
  
  module.hot.accept("./SchedulerApostille.vue?vue&type=template&id=5b079f8b", () => {
    api.rerender('5b079f8b', render)
  })

}


export default __exports__